// eslint-disable-next-line no-unused-vars
import { USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/mission'
const state = {
}

const mutations = {
}

const actions = {

	/**
     * 미션 정보 조회
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
	// eslint-disable-next-line no-unused-vars
    async getMissionOverview ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/overview`, payload)
    },

    /**
        * 미션 정보 조회
        * @param commit
        * @param payload
        * @returns {Promise<unknown>}
        */
    // eslint-disable-next-line no-unused-vars
    async getTodayMissionUnits ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/days/{day}`, payload)
    },

	/**
     * 미션 전체 수행률 조회
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
	// eslint-disable-next-line no-unused-vars
    async getTotalMissionRate ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/progress-rate`, payload)
    },

}

export default { state, mutations, actions }
